import axios from "axios";
import { SET_TAGS } from "./../types/tagsTypes";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";
import axiosInstance from "../../axios";

export const setAllTags = (tags) => ({ type: SET_TAGS, payload: tags });

export const fetchAllTags = () => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.get(`/model/tags`);
      dispatch(requestSucceeded());
      const tags = res.data.data;
      dispatch(setAllTags(tags));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};
